(function () {
  const root = (window.NettyNature = window.NettyNature || {});

  async function fetchJson(url, init) {
    const res = await fetch(url, Object.assign({ credentials: 'same-origin' }, init));
    let body;
    try { body = await res.json(); } catch (_) { body = null; }
    if (!res.ok) {
      const err = new Error((body && body.description) || res.statusText);
      err.body = body;
      err.status = res.status;
      throw err;
    }
    return body;
  }

  async function addItem(variantId, quantity, properties) {
    const payload = { id: Number(variantId), quantity: Number(quantity) || 1 };
    if (properties) payload.properties = properties;
    const item = await fetchJson('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    const cart = await getCart();
    dispatch('nn:cart:added', { item, cart });
    dispatch('nn:cart:updated', { cart });
    return cart;
  }

  async function changeLine(line, quantity) {
    const cart = await fetchJson('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
    });
    dispatch('nn:cart:updated', { cart });
    return cart;
  }

  async function getCart() {
    return fetchJson('/cart.js');
  }

  function dispatch(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
  }

  function applyCount(cart) {
    const count = (cart && typeof cart.item_count === 'number') ? cart.item_count : 0;
    document.querySelectorAll('[data-nn-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
    const links = document.querySelectorAll('[data-nn-cart-link]');
    links.forEach((a) => a.setAttribute('aria-label', 'Cart, ' + count + ' items'));
  }

  document.addEventListener('nn:cart:updated', (event) => applyCount(event.detail.cart));

  root.cart = { addItem, changeLine, getCart };
})();
